export default __webpack_public_path__ + "static/media/Alpha-FX-Full-logo-old.295f7cc1.png";